import { STATUS_PAST_DUE } from '@/constants/constants'
import { isAdvancedPlan } from '@/constants/userSubscriptionPlans'
import { useAuth } from '@/hooks'

export const useInfoBanner = () => {
  const { planId, paymentProvider, subscriptionStatus } = useAuth()

  const displayBraintreeAlert =
    paymentProvider === 'braintree' &&
    subscriptionStatus === 'Active' &&
    isAdvancedPlan(planId)

  // OCT-5150: a renewal Stripe could not charge. The plan is still on while
  // the retries run, so this is the only place in the product that says the
  // card needs fixing before it ends.
  const displayPaymentFailedBanner = subscriptionStatus === STATUS_PAST_DUE

  return {
    displayBraintreeAlert,
    displayPaymentFailedBanner,
  }
}
